<template>
    <div>
        <DCard
            padding
        >
            <ContactsForm
                ref="createForm"
                :errors="errors"
                :contact="contact"
                :countries="countries"
                :titles="titles"
                @submit="storeContact"
            />
        </DCard>
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import ContactsForm from '~@/Components/Customers/Contacts/Form'

export default {
    name: 'CustomerContactCreate',
    components: {
        ContactsForm
    },
    layout: [App, CustomerBase],
    props: {
        customer: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        countries: {
            type: Array,
            default: () => { return [] }
        },
        titles: {
            type: Array,
            default: () => { return [] }
        },
        customerId: {
            type: Number,
            default: 0
        },
        stickyNotes: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            contact: { customer_id: this.customerId }
        }
    },
    methods: {
        storeContact (form) {
            form.post(this.$route('customers.customers.contacts.store', {
                customer: this.customerId
            }))
        }
    }
}
</script>
